import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import GlobalTheme from '../../../styled/GlobalTheme';
import mediaQueries from '../../../utils/mediaQueries';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
  ${GlobalTheme.breakpoints.down('sm')} {
    align-items: center;
    padding: 30px 0 0 0;
  }
  @media (max-height: 425px) {
    align-items: center;
    padding: 30px 0 0 0;
  }
`;

const Text = styled.div`
  font-size: 14px;
  padding: 0;
  width: 100%;
  text-align: center;
  line-height: 19px;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colors.grayMediaLibrary};
  text-align: center;
  @media ${mediaQueries.mdUp} {
    font-size: 18px;
    line-height: 25px;
    max-width: 650px;
    margin-bottom: 38px;
  }
  @media (max-height: 425px) {
    font-size: 14px;
    line-height: 19px;
  }
`;

const HeaderBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  ${GlobalTheme.breakpoints.down('sm')} {
    flex-direction: column;
    align-items: center;
  }
  @media (max-height: 425px) {
    height: fit-content;
    align-items: center;
  }
`;

const HeaderSlider = ({ text }) => (
  <Container>
    <HeaderBox>
      <Text>{text}</Text>
    </HeaderBox>
  </Container>
);

HeaderSlider.propTypes = {
  text: PropTypes.string.isRequired,
};

export default HeaderSlider;
